import { render, staticRenderFns } from "./AccountRewardsPointsComponent.vue?vue&type=template&id=22690f5e"
import script from "./AccountRewardsPointsComponent.vue?vue&type=script&lang=js"
export * from "./AccountRewardsPointsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports